import React from 'react'
import styled from 'styled-components'
import Spacer from '../../lib/spacer'
import BulletPoint from '../../common/bullet_point'
import injuriesFocusAreasAbstract from './img/injuries-focus-areas-abstract.webp'
import ReadMoreButton from '../../common/read_more_button'
import { FaBullseye, FaShieldAlt } from 'react-icons/fa'
import PlusBadge from '../../common/plus_badge'
import { useTranslation, Trans } from '../../lib/i18n'

const Wrapper = styled.div`
    background-color: ${(props) => props.theme.palette.greyScale.lightestGrey};
    border-top: 1px solid ${(props) => props.theme.palette.greyScale.lighterGrey};
    border-bottom: 1px solid ${(props) => props.theme.palette.greyScale.lighterGrey};
`

export default () => {
    const { t } = useTranslation(undefined, { keyPrefix: 'home.achesPains' })

    return (
        <Wrapper>
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={50} className="show-for-small-only" />
            <div className="main grid-container">
                <div className="grid-x">
                    <div className="cell medium-12 text-center">
                        <h2 className="h1">
                            {t('titleLine1')} <br /> {t('titleLine2')}
                        </h2>
                        <Spacer size={30} />
                        <div className="grid-x align-center">
                            <div className="cell medium-7 text-center">
                                <p className="lead">{t('lead')}</p>
                            </div>
                        </div>
                        <Spacer className="hide-for-small-only" size={70} />
                        <Spacer className="show-for-small-only" size={30} />
                    </div>
                </div>
                <div className="grid-x align-justify">
                    <div className="cell medium-6">
                        <img src={injuriesFocusAreasAbstract} alt={t('imageAlt')} />
                    </div>
                    <div className="cell medium-5">
                        <div className="grid-y">
                            <Spacer size={70} />
                            <BulletPoint icon={FaBullseye} className="cell medium-6">
                                <h4>{t('focusAreas.title')} <PlusBadge /></h4>
                                <p>{t('focusAreas.p1')}</p>
                                <br />
                                <p>{t('focusAreas.p2')}</p>
                            </BulletPoint>
                            <BulletPoint icon={FaShieldAlt} className="cell medium-6">
                                <h4>{t('injuries.title')} <PlusBadge /></h4>
                                <p>{t('injuries.p1')}</p>
                                <br />
                                <p>{t('injuries.p2')}</p>
                                <ReadMoreButton>
                                    <h2>{t('readMore.heading')}</h2>
                                    <p>{t('readMore.intro')}</p>
                                    <p>
                                        <Trans i18nKey="home.achesPains.readMore.focus" components={[<strong key="0" />]} />
                                    </p>
                                    <p>
                                        <Trans i18nKey="home.achesPains.readMore.injury" components={[<strong key="0" />]} />
                                    </p>
                                    <p>{t('readMore.outro')}</p>
                                </ReadMoreButton>
                            </BulletPoint>
                        </div>
                    </div>
                </div>
            </div>
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={70} className="show-for-small-only" />
        </Wrapper>
    )
}
